import { gql } from "@apollo/client";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";

export const CREATE_UNIVERSITY_PROBATION_MUTATION = gql`
  mutation CreateUniversityProbation($input: BackofficeEducationCreateUniversityProbationInput!) {
    createUniversityProbation(input: $input) {
      code
      success
      message
      universityProbation {
        id
        university {
          id
          name
        }
        person {
          id
          firstName
          lastName
          displayName
          pgaId
          email
          profilePhoto
        }
        startedAt
        active
        probationType
        notes {
          ...CRMNoteFields
        }
      }
    }
  }
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;

export const CREATE_UNIVERSITY_PROBATIONS_MUTATION = gql`
  mutation CreateUniversityProbations($input: BackofficeEducationCreateUniversityProbationsInput!) {
    createUniversityProbations(input: $input) {
      code
      success
      message
      universityProbations {
        id
        university {
          id
          name
        }
        person {
          id
          firstName
          lastName
          displayName
          pgaId
          email
          profilePhoto
        }
        startedAt
        active
        probationType
        notes {
          ...CRMNoteFields
        }
      }
    }
  }
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;

export const END_UNIVERSITY_PROBATION_MUTATION = gql`
  mutation EndUniversityProbation($input: BackofficeEducationEndUniversityProbationInput!) {
    endUniversityProbation(input: $input) {
      code
      success
      message
      universityProbation {
        id
        endedAt
        active
        notes {
          ...CRMNoteFields
        }
      }
    }
  }
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;

export const UPDATE_UNIVERSITY_PROBATION_MUTATION = gql`
  mutation UpdateUniversityProbation($input: BackofficeEducationUpdateUniversityProbationInput!) {
    updateUniversityProbation(input: $input) {
      code
      success
      message
      universityProbation {
        id
        probationType
        active
        startedAt
        endedAt
      }
    }
  }
`;
